module.exports = __webpack_public_path__ + "static/media/powered-by-LV-logo.3fff4ff8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/powered-by-LV-logo.svg
// module id = 4086
// module chunks = 0